<template>
  <!-- 离线配置改动点2 -->
  <div class="projectConfig app-wrapper dream">
    <childNav :routerName="$t('updateNewSip.moduleName')" :backFlag="true"  @clearCase="clearCase"></childNav>
    <!-- 内容 -->
    <div class="app-content config-body">
      <Row gutter="20" class="full-box">
        <i-col span="3">
          <project-step
            :step-two-class="currentStep === 0 ? 'step2_no' : 'step2_active'"
            :step-three-class="currentStep === 2 ? 'step3_active' : 'step3_no'"
            @setCurrentStep="setCurrentStep"
          ></project-step>
        </i-col>
        <i-col span="19">
          <h3 class="tip-color margin-bottom-20">
            <Icon type="md-information-circle" ssize="30" color="#fc7790" />
            {{ $t("deviceSip.saveTip") }}
          </h3>
          <!-- 项目配置 步骤1 -->
          <community-config
            v-if="currentStep === 0"
            ref="communityConfig"
            :key="timeStamp"
            :current-step="currentStep"
            @setCurrentStep="setCurrentStep"
          ></community-config>
          <!-- 区域配置 步骤2 -->
          <area-config
            v-if="currentStep === 1"
            ref="areaConfig"
            :key="timeStamp"
            :current-step="currentStep"
            @setCurrentStep="setCurrentStep"
          ></area-config>
          <!-- 设备配置 步骤3 -->
          <device-config
            v-if="currentStep === 2"
            ref="deviceConfig"
            :current-step="currentStep"
            @setCurrentStep="setCurrentStep"
          ></device-config>
        </i-col>
      </Row>
    </div>
  </div>
</template>
<script>
import areaConfig from "./components/areaConfig";
import deviceConfig from "./components/deviceConfig";
import communityConfig from "./components/communityConfig";
import projectStep from "./components/projectStepThree";
import childNav from "@/components/homeNav/childNav.vue";

export default {
  name: "projectConfig",
  components: {
    areaConfig,
    deviceConfig,
    projectStep,
    communityConfig,
    childNav,
  },
  filters: {},
  directives: {},
  mixins: {},
  props: {},
  data() {
    return {
      timeStamp: new Date().getTime(),
      currentStep: 0,
      areaData: [], // 所有的区域层级
      areaDeviceData: [], // 所有的区域与设备的层级
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    window.addEventListener("click", this.cancelChosen);
  },
  beforeUpdate() {},
  beforeDestroy() {},
  beforeRouteEnter(to, from, next) {
    next();
  },
  beforeRouteLeave(to, from, next) {
    next();
  },
  methods: {
    // 接受子组件的数据
    setCurrentStep(val) {
      debugger;
      if (this.currentStep === 0 && Number(val) > 0) {
        // 通过步骤条快捷跳转
        let isAllowToNext = this.$refs.communityConfig.setCurrentStep(0);
        if (!isAllowToNext) {
          return;
        }
      }
      this.currentStep = Number(val);
    },
    // 判断当前浏览器是否有path
    composedPath(e) {
      // 存在则直接return
      if (e.path) {
        return e.path;
      }
      // 不存在则遍历target节点
      let target = e.target;
      e.path = [];
      while (target.parentNode !== null) {
        e.path.push(target);
        target = target.parentNode;
      }
      // 最后补上document和window
      e.path.push(document, window);
      return e.path;
    },

    // 取消选中
    cancelChosen($event) {
      let path = this.composedPath($event);
      let pathList = path.map((i) => {
        return JSON.stringify(i.classList);
      });
      pathList = pathList.join();
      if (pathList.includes("no-cancel-tree")) {
        return;
      }
      if (pathList.includes("ivu-modal-mask")) {
        return;
      }
      if (pathList.includes("ivu-modal-wrap")) {
        return;
      }
      if (this.$refs.areaConfig) {
        this.$refs.areaConfig.$refs.configTree.$emit("selectTree", {});
        this.$refs.areaConfig.$refs.configTree.$refs.tree.setCurrentKey();
      }
      if (this.$refs.deviceConfig) {
        // 初始设备节点
        let node = {
          isTopDevice: null,
          name: "",
          funList: [],
          netInfoDTO: {
            mode: 1,
            mask: "",
            gateway: "",
            ip: "",
            dns1: "",
            dns2: "",
          },
          sipInfoDTOList: [],
        };
        this.$refs.deviceConfig.$refs.configTree.$emit("selectTree", node);
        this.$refs.deviceConfig.$refs.configTree.$refs.tree.setCurrentKey();
      }
    },
    // 清除区域信息配置
    clearCase() {
      // 设置项目信息为空
      this.$store.commit("projectConfig/SET_PROJECTINFO", {});
    },
  },
};
</script>
<style lang="scss" scoped>
.projectConfig {
  width: 100%;
  height: 100%;
  background: #eef6fa;
  margin-top: 50px;
}
.config-body {
  height: 92%;
  padding: 30px 50px;
  overflow: hidden;
}
.center-box {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 300px;
}
.full-box {
  width: 100%;
  height: 90%;
}
.tip-box {
  color: #fc7790;
}
</style>
